import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import GlobalError from 'components/GlobalError';
import MainContent from 'components/MainContent';
import UsersList from 'components/Users/UsersList';
import UsersSearch from 'components/Users/UsersSearch';
import { Loading } from 'components/Loading';
import Button from '@ontruck/ontruck-react-components/lib/Button';
import { withRouter } from 'react-router-dom';
import { searchStaff, fetchStaff, fetchMoreStaff } from 'redux/modules/staff/effects';
import { getAllStaff, getStaffNextURL } from 'redux/modules/staff/selectors';
import config from 'config';
import styles from './styles.module.scss';

class OnTruckUsersList extends Component {
  componentDidMount() {
    this.props.fetchStaff();
  }

  handleEdit = (id) => {
    const { history } = this.props;
    history.push({ pathname: `${config.BASE_ROUTE}user/${id}` });
  };

  toggleModal = () => {
    const { history } = this.props;
    history.push({ pathname: `${config.BASE_ROUTE}user/new` });
  };

  render() {
    const {
      intl,
      searchStaff,
      searching,
      fetchMoreStaff,
      users,
      totalUsers,
      threshold,
      hasNextPage,
      loading,
      loadingMore,
      serverError,
    } = this.props;

    const t = intl.messages.containers.Users;

    return (
      <Fragment>
        <div className={styles.noGrow}>
          <MainContent>
            <h1>{t.title}</h1>
            <div className={styles.actionsContainer}>
              <UsersSearch onSearch={searchStaff} reset={!searching} />
              <Button type="button" onClick={this.toggleModal}>
                {t.add_new_user_btn}
              </Button>
            </div>
          </MainContent>
        </div>
        {!!serverError && !!serverError.errors && serverError.errors.length > 0 ? (
          <GlobalError
            messages={Object.keys(serverError.errors).map((error_key) => (
              <span key={error_key}>{serverError.errors[error_key]}</span>
            ))}
          />
        ) : null}
        <div className={styles.grow}>
          {loading ? (
            <Loading size={60} className={styles.loading} />
          ) : (
            <UsersList
              users={users}
              total={totalUsers}
              hasNextPage={hasNextPage}
              isNextPageLoading={loadingMore}
              onLoadMoreRows={fetchMoreStaff}
              threshold={threshold}
              onRowClick={this.handleEdit}
            />
          )}
        </div>
      </Fragment>
    );
  }
}

OnTruckUsersList.propTypes = {
  users: PropTypes.arrayOf(PropTypes.object),
  hasNextPage: PropTypes.bool,
  threshold: PropTypes.number,
  serverError: PropTypes.object,
  loading: PropTypes.bool,
  searching: PropTypes.bool.isRequired,
  loadingMore: PropTypes.bool,
  totalUsers: PropTypes.number,
  fetchStaff: PropTypes.func,
  fetchMoreStaff: PropTypes.func,
  searchStaff: PropTypes.func,
  intl: PropTypes.object.isRequired,
};

const mapStateToProps = (state, { match }) => ({
  users: getAllStaff(state),
  pageSize: state.staff.pageSize,
  serverError: state.staff.error,
  loading: state.staff.fetching,
  searching: state.staff.searching,
  loadingMore: state.staff.fetchingMore,
  totalUsers: state.staff.count,
  hasNextPage: !!getStaffNextURL(state),
  threshold: state.staff.pageSize / 2,
});

const mapDispatchToProps = {
  searchStaff,
  fetchStaff,
  fetchMoreStaff,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(OnTruckUsersList))
);
